import { NgxModule } from './ngx.module';
import { ExportModule as AdminPermissionExportModule} from 'AdminPermission/export.module';
import { ExportModule as AdminExportModule} from 'Admin/export.module';
export const NgxModules = [
    NgxModule,
    AdminPermissionExportModule,
    AdminExportModule
];
